/* ---------- WELCOME IN THE FRANCKYSTYLE 🐸 ---------- */
/* please don't touch: anything; and please eat a merguez; bizous */

/* ---------- HORAIRES LIVE + DATE + HEURE + EXCEPTIONS ---------- */
/*
Ce fichier gère :
✅ L'affichage de la date et l'heure en live
✅ Le statut du magasin (Ouvert/Fermé) en temps réel
✅ L'affichage des horaires habituels
✅ La prise en compte des horaires exceptionnels
✅ L'affichage des horaires exceptionnels sur la page contact
✅ L'override des horaires habituels si un horaire exceptionnel est prévu

👉 Modifiez uniquement les parties HORAIRES HABITUELS et HORAIRES EXCEPTIONNELS !
👉 Pour désactiver un horaire exceptionnel sans le supprimer, mettez-le en commentaire

📌 Format des horaires :
- Chaque créneau horaire est sous forme de tableau [heure d'ouverture, heure de fermeture]
- Les demi-heures sont indiquées par .5 (ex: 10h30 → 10.5, 14h → 14)
- Les horaires exceptionnels doivent être au format "YYYY-MM-DD"
*/

document.addEventListener("DOMContentLoaded", function () {
  /* ---------- HORAIRES HABITUELS ---------- */
  const horaires = {
    1: [], // Lundi : Fermé
    2: [
      [10, 12.5],
      [14, 19],
    ], // Mardi
    3: [
      [10, 12.5],
      [14, 19],
    ], // Mercredi
    4: [
      [10, 12.5],
      [14, 19],
    ], // Jeudi
    5: [
      [10, 12.5],
      [14, 19],
    ], // Vendredi
    6: [
      [10, 12.5],
      [14, 19],
    ], // Samedi
    0: [], // Dimanche : Fermé
  };

  /* ---------- HORAIRES EXCEPTIONNELS ---------- */
  const horairesExceptionnels = {
  };

  /* -- LISTE D'EXEMPLE CODES HORAIRES EXCEPTIONNELS
    "2025-09-29": [[14, 19]], // Ouvert uniquement sur une demi journée
    "2025-09-26": [], // Fermé toute la journée
    "2025-12-24": [
      [11, 12],
      [15, 17],
    ], // Ouvert toute la journée mais différent des habituels (les retours à la ligne sont obligatoire)
    -- */

  /* ---------- MISE À JOUR DATE & HEURE LIVE ---------- */
  function updateDateTime() {
    const now = new Date();

    // 📆 Date au format DD/MM/YYYY
    const day = now.getDate().toString().padStart(2, "0");
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const year = now.getFullYear();
    document.getElementById("today").textContent = `${day}/${month}/${year}`;

    // 🕒 Heure (mise à jour chaque minute)
    const heure = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    document.getElementById("time").textContent = `${heure}:${minutes}`;

    checkOuverture(now);
  }

  /* ---------- VÉRIFICATION SI LE MAGASIN EST OUVERT OU FERMÉ ---------- */
  function checkOuverture(now) {
    const today = now.toISOString().split("T")[0]; // Format YYYY-MM-DD
    const jour = now.getDay();
    const heure = now.getHours() + now.getMinutes() / 60;

    // Vérifie d'abord les horaires exceptionnels, sinon utilise les horaires habituels
    let ouvertures =
      horairesExceptionnels[today] !== undefined
        ? horairesExceptionnels[today]
        : horaires[jour];

    let ouvert = false;
    ouvertures.forEach(([debut, fin]) => {
      if (heure >= debut && heure < fin) ouvert = true;
    });

    // Affichage du statut (Ouvert/Fermé)
    const statutBoutique = document.getElementById("statut-boutique");
    statutBoutique.innerHTML = ouvert
      ? `<span style="color: #733400; font-weight: 700;">Ouvert</span>`
      : `<span style="color: #494949;">Fermé</span>`;
  }

  /* ---------- AFFICHAGE DES HORAIRES HABITUELS SUR LA PAGE CONTACT ---------- */
  function afficherHoraires() {
    const jours = [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ];
    let horairesHTML = "<ul>";

    for (let i = 1; i <= 6; i++) {
      // De Lundi (1) à Samedi (6)
      if (horaires[i].length === 0) {
        horairesHTML += `<li><strong>${jours[i]} :</strong> Fermé</li>`;
      } else {
        let horairesJour = horaires[i]
          .map(([debut, fin]) => `${formatHeure(debut)} - ${formatHeure(fin)}`)
          .join(" / ");
        horairesHTML += `<li><strong>${jours[i]} :</strong> ${horairesJour}</li>`;
      }
    }

    // Dimanche en dernier
    horairesHTML += `<li><strong>${jours[0]} :</strong> ${
      horaires[0].length ? horaires[0] : "Fermé"
    }</li>`;
    horairesHTML += "</ul>";

    document.getElementById("horaires-habituels").innerHTML = horairesHTML;
  }

  /* ---------- AFFICHAGE DES HORAIRES EXCEPTIONNELS SUR LA PAGE CONTACT ---------- */
  function afficherHorairesExceptionnels() {
    let horairesExcepHTML = "<ul>";

    if (Object.keys(horairesExceptionnels).length === 0) {
      horairesExcepHTML += "<li>Rien à signaler pour le moment.</li>";
    } else {
      for (const [date, horaires] of Object.entries(horairesExceptionnels)) {
        const [year, month, day] = date.split("-");
        let formattedDate = `${day}/${month}/${year}`;

        if (horaires.length === 0) {
          horairesExcepHTML += `<li><strong>${formattedDate} :</strong> Fermé</li>`;
        } else {
          let horairesJour = horaires
            .map(
              ([debut, fin]) => `${formatHeure(debut)} - ${formatHeure(fin)}`
            )
            .join(" / ");
          horairesExcepHTML += `<li><strong>${formattedDate} :</strong> ${horairesJour}</li>`;
        }
      }
    }

    horairesExcepHTML += "</ul>";
    document.getElementById("horaires-exceptionnels").innerHTML =
      horairesExcepHTML;
  }

  /* ---------- FORMATAGE DES HEURES (CORRIGE LES .5 EN h30) ---------- */
  function formatHeure(h) {
    let heures = Math.floor(h);
    let minutes = h % 1 === 0.5 ? "30" : "00"; // Corrige le bug des ".5"
    return `${heures}h${minutes}`;
  }

  /* ---------- INIT (DÉMARRE LE SCRIPT) ---------- */
  updateDateTime();
  afficherHoraires();
  afficherHorairesExceptionnels();
  setInterval(updateDateTime, 60000); // Met à jour toutes les minutes
});

/* ---------- PAGE ACCEUIL ---------- */
/* supression de comparer sur les produits acceuil */
/*
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const compareSections = document.querySelectorAll(
      "#Slider-template--23611678556502__featured_collection_MAg4RX sc-add-to-compare"
    );

    compareSections.forEach((section) => {
      section.remove();
      console.log("Élément supprimé :", section);
    });
  }, 1000);
});
*/

/* ---------- REGLAGE DE LA LOOP VIDEO SLIDER ---------- */

document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".video-intro-jsloop");

  if (video) {
    video.addEventListener("ended", function () {
      video.currentTime = 3; // Change "3" par le temps (en secondes) où tu veux que ça recommence
      video.play();
    });
  }
});
